import { useFormik } from "formik";
import { SeguimientoCreationDTO } from "../../types/Seguimiento/SeguimientoCreationDTO";
import { seguimientoSchema } from "../validationsForm/ValidationSeguimientoSchema";
import { Alert, Button, FormControl, Grid, TextField } from "@mui/material";
import SegumientoService from "../../services/SeguimientoService";
import { GenericResponse } from "../../types/Response/GenericResponse";

interface Props {
    idanuncio: number;
    onResponse?: (dataRespuesta: GenericResponse) => void
}

export const SeguimientoForm: React.FC<Props> = ({ idanuncio, onResponse }) => {
    const formik = useFormik<SeguimientoCreationDTO>({
        initialValues: {
            idAnuncio: idanuncio,
            txObservacion: '',
            bdIsReiterativo: 0,
            bdEstado: 'R'
        },
        validationSchema: seguimientoSchema,
        onSubmit: (values) => {
            observacion(values);
        },
    });
    // Funciones
    const observacion = (obj: SeguimientoCreationDTO) =>{
        SegumientoService.UpdateStatus(obj)
        .then((resp) => {
            if (onResponse) {
                onResponse(resp);
            } else {
                console.error('La función onResponse no está definida.');
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container maxWidth="lg" style={{ border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', borderTopWidth: '3px', textAlign: 'center' }}>
                <Grid item sm={12}>
                    {formik.touched.idAnuncio && formik.errors.idAnuncio && (
                        <Alert variant="filled" severity="error" style={{ marginTop: '1px' }}>
                            {formik.errors.idAnuncio}
                        </Alert>
                    )}
                </Grid>
                <Grid item sm={12}>
                    <FormControl fullWidth margin="normal" error={formik.touched.txObservacion && Boolean(formik.errors.txObservacion)}>
                        <TextField
                            id="txObservacion"
                            name="txObservacion"
                            label='Observación'
                            type="text"
                            multiline
                            rows={5}
                            value={formik.values.txObservacion}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txObservacion && Boolean(formik.errors.txObservacion)}
                        />
                        {formik.touched.txObservacion && formik.errors.txObservacion && (
                            <Alert variant="filled" severity="error" style={{ marginTop: '1px' }}>
                                {formik.errors.txObservacion}
                            </Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item sm={12}>
                    <Button color="primary" variant="contained" fullWidth type="submit" sx={{ m: 2 }}>
                        Enviar
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
}